const mutable = (val) => val;

export { mutable };
//# sourceMappingURL=typescript.mjs.map
